import { generateClient } from 'aws-amplify/api';
import { createUser } from "../graphql/mutations";

const client = generateClient();

export default async ({ email, userId, firstName, lastName, phoneNumber, createdAt, updatedAt, isNotificationEnable, ...args }) => {
    try {
        const{
            data: { createUser: createdUser },
        } = await client.graphql({
            query: createUser,
            variables: {
                input: {
                    ...args
                },
            },
        });
        return createdUser;
    } catch (ex) {
        console.error("Failed to create user", ex);
    }
};